'use strict';

// Constructor
export class Webforms {
	constructor() {
		this.workingWithChildren();
	}

	workingWithChildren() {
		$("body").on("change", "#edit-civicrm-1-activity-1-cg71-custom-271", function () {
			var contries = ['1642', '1645'];
			var selectedIndex = $.inArray($(this).val(), contries);
			var show_radio = true;
			if (selectedIndex >= 0 && !$('#edit-submitted-civicrm-1-activity-1-cg71-custom-280-1').is(':checked')) {
				show_radio = false;
				$("#edit-civicrm-1-activity-1-activity-status-id-11").prop('checked', show_radio);
			}
			$("#edit-civicrm-1-activity-1-activity-status-id-11").closest('fieldset').toggle(show_radio);
		});
	}
}